export {BANK_BRANCH_COUNTRIES as hasBankBranch} from "../../../../../../../features/bank-accounts/domain/bank-account.types";
export const ACCOUNT_NUMBER_PATTERNS: Record<string, RegExp> = {
  // Non-EU countries
  NG: /^\d{10}$/,
  GH: /^\d{10,12}$/,
  ZA: /^\d{10,12}$/,
  KE: /^\d{10,12}$/,
  UG: /^\d{10,12}$/,
  TZ: /^\d{10,12}$/,
  // Bank-branch countries
  SL: /^\d{10,12}$/,
  CM: /^\d{10,12}$/,
  TD: /^\d{10,12}$/,
  CG: /^\d{10,12}$/,
  GA: /^\d{10,12}$/,
  BJ: /^\d{10,12}$/,
  CI: /^\d{10,12}$/,
  SN: /^\d{10,12}$/,
};

export type BankName = {
  code: string;
  id: number;
  name: string;
  hasBankBranch: boolean;
};

export function handleBankName({
  banks,
  selectedBank,
}: {
  banks: {code: string; id: number; name: string; hasBankBranch: boolean}[];
  selectedBank: string;
}): BankName | undefined {
  return banks.find((c) => c.code === selectedBank);
}
